import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams, HttpErrorResponse } from "@angular/common/http";
import { Currency, CacheService } from "mapfre-auditlib";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import * as _ from 'lodash';

@Injectable({
   providedIn: "root"
})
export class CurrencyService {

   className = 'CurrencyService';

   constructor(private http: HttpClient, private cacheService: CacheService) { }

   getAllCurrencies(cache = true, cacheKey = "allCurrencies"): Observable<Currency[]> {
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
       } else {
         let observable = this.http.get<Currency[]>(environment.base_URL + "/currencies").pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }

   newCurrency(currency) {
      return this.http.post(environment.base_URL + "/currencies", currency)
   }

   updateCurrency(currency, id) {
      return this.http.put(environment.base_URL + `/currencies/${id}`, currency)
   }

   deleteCurrency(id: Number) {
      return this.http.delete(environment.base_URL + `/currencies/${id}`)
   }
}
